export default __webpack_public_path__ + "static/media/ig-gradient-plan-pack-enterprise.8c25b7b0.webp";